import axios from 'axios'
const config = require('../../config/index')
const crypto = require('crypto')

const instance = axios.create({
    baseURL: config.dev.hostApi+"/api/openapi/",
    timeout: 10000
})

// TODO: 把下面的 SECRET 换成后端给你的签名密钥
const REQUEST_SECRET = 'XGbpB1bCcKeMmwLI'

instance.interceptors.request.use(requestConfig => {
    const timeStamp = Date.now().toString()
    const payload = requestConfig.method === 'get' ? requestConfig.params : requestConfig.data

    let payloadString = ''
    if (payload) {
        if (typeof payload === 'string') {
            payloadString = payload
        } else if (payload instanceof FormData) {
            payloadString = ''
        } else {
            payloadString = JSON.stringify(payload)
        }
    }

    const signSource = `${timeStamp}|${REQUEST_SECRET}`
    const sign = crypto.createHash('md5').update(signSource).digest('hex')

    requestConfig.headers = requestConfig.headers || {}
    requestConfig.headers['TimeStamp'] = timeStamp
    requestConfig.headers['Sign'] = sign

    return requestConfig
}, error => Promise.reject(error))

export default instance


// WEBPACK FOOTER //
// ./src/api/index.js